__turbopack_context__.v({
  "item": "Xzno1a_item",
  "popup": "Xzno1a_popup",
  "positioner": "Xzno1a_positioner",
  "separator": "Xzno1a_separator",
  "trigger": "Xzno1a_trigger",
});
